import type { Id } from "@convex/_generated/dataModel";

/** Cheia sub care stă tokenul de sesiune al utilizatorului. */
export const USER_SESSION_KEY = "userSessionToken";

/**
 * Identitatea utilizatorului din browser.
 *
 * `userId` singur nu mai deschide nimic pe server — fiecare apel are nevoie și
 * de token, iar serverul verifică faptul că tokenul chiar aparține acelui cont.
 * Le citim împreună tocmai ca să nu rămână cod care trimite doar ID-ul.
 */
export function getStoredUserSession(): {
  userId: Id<"users"> | null;
  sessionToken: string | null;
} {
  const userId = localStorage.getItem("userId") as Id<"users"> | null;
  const sessionToken = localStorage.getItem(USER_SESSION_KEY);
  return { userId, sessionToken };
}

/** Argumentele comune pentru orice apel care cere identitate, sau `"skip"`. */
export function userArgs(): { userId: Id<"users">; sessionToken: string } | "skip" {
  const { userId, sessionToken } = getStoredUserSession();
  if (!userId || !sessionToken) return "skip";
  return { userId, sessionToken };
}

export function clearUserSession() {
  localStorage.removeItem(USER_SESSION_KEY);
  localStorage.removeItem("userId");
}
